import {DrillDownStatisticsLevel} from '@dms/api/core';

export function getKeyFromLevels(levels: DrillDownStatisticsLevel[]): string {
  return levels.map((level) => level.value).join('-');
}
